import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './tab-content.module.less';

export const DeprecatedTabContent = ({ className = '', children = emptyArray }) => {
  return <div className={classnames(style['tab-content-old'], className)}>{children}</div>;
};

DeprecatedTabContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
